module.exports = __webpack_public_path__ + "img/TNTO-logo.79729ef9.png";